<ion-header no-border>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="color-dark" data-cy="editReview-toolbar-title">Filter Leads</ion-title>
    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary" ion-button (click)="done()">
        Done
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>

  <div class="spacer-15"></div>
  <div class="partialLeadsDiv pad-left-10" *ngIf="userRole === 'agent'">

    <ion-checkbox labelPlacement="end" [(ngModel)]="partialLeadOption.isSelected" mode="ios">
      Include Partial Entries</ion-checkbox><ion-icon class="infoIcon" color="primary" tappable
      (click)="leadPartialInfo($event)" ios="information-circle-sharp" md="information-circle-sharp"></ion-icon>
  </div>

  <div class="partialLeadsDiv pad-left-10" *ngIf="userRole === 'lender'">

    <ion-checkbox labelPlacement="end" [(ngModel)]="withoutMortgageOptInLeadOption.isSelected" mode="ios">
      Include Leads without
      Opt-in</ion-checkbox>


    <ion-icon class="infoIcon" color="primary" tappable (click)="leadWithoutMortgageInfo($event)"
      ios="information-circle-sharp" md="information-circle-sharp"></ion-icon>
  </div>
  <div class="listingAddressTitle">
    <label>Listing Address</label>
  </div>

  <div class="pad-left-10">

    <ion-radio-group lines="none" radio-group (ionChange)="handleSelection($event.detail)"
      [(ngModel)]="currentSelection">

      <ion-radio labelPlacement="end" mode="ios" value="0"><ion-label>Select
          All</ion-label></ion-radio>

      <div *ngFor="let item of filterOptions; index as i">

        <ion-radio labelPlacement="end" mode="ios" (ngModelChange)="selectedListingChanged(item, i, $event)"
          [value]="item.listingId">{{item.listings.address.title}}</ion-radio>

      </div>
    </ion-radio-group>
  </div>

  <div class="spacer-15"></div>
</ion-content>